/* ============================================================
   carlios. v2 — shared behaviors
   Small, progressive-enhancement only. Section-specific logic
   (e.g. the Diagnostica quiz) lives in its own asset.
   ============================================================ */
(function () {
  'use strict';

  /* FAQ: one <details open> at a time, inside any [data-faq] container. */
  function initFaqAccordion() {
    document.querySelectorAll('[data-faq]').forEach(function (group) {
      var items = group.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (other) {
            if (other !== d) other.open = false;
          });
        });
      });
    });
  }

  /* Sticky mobile bar: hidden on arrival, revealed only once the hero CTA
     has scrolled out of view. Progressive enhancement — if anything is
     missing or IntersectionObserver is unsupported, the bar stays hidden
     (CSS default) and the in-hero CTA still works. */
  function initStickyBar() {
    var bar = document.querySelector('[data-mbar]');
    var sentinel = document.querySelector('[data-mbar-after]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    obs.observe(sentinel);
  }

  /* Analytics — custom homepage events.
     Publishes to Shopify Customer Events (Shopify.analytics.publish): a Custom
     Pixel subscribes to `carlios:*` and forwards to GA4. Also mirrors each event
     to window.dataLayer so a future GTM works with no rework. Pure enhancement:
     guarded, never blocks navigation, no-ops cleanly if Shopify isn't present
     (e.g. the local preview harness). Set window.__carliosTrackDebug = true (or
     localStorage 'carliosTrackDebug') to console.debug every event. */
  function track(name, data) {
    data = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('carlios:' + name, data);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var row = { event: 'carlios_' + name };
      for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) row[k] = data[k]; }
      window.dataLayer.push(row);
    } catch (e) {}
    if (window.__carliosTrackDebug || (window.localStorage && localStorage.getItem('carliosTrackDebug'))) {
      try { console.debug('[carlios:ga]', name, data); } catch (e) {}
    }
  }
  window.carliosTrack = track; // section JS (e.g. the Diagnostica quiz) fires events through this

  function locationOf(el) {
    if (!el || !el.closest) return 'other';
    if (el.closest('[data-mbar]')) return 'mobile_bar';
    if (el.closest('.site-nav')) return 'header';
    if (el.closest('.site-footer')) return 'footer';
    if (el.closest('.hero')) return 'hero';
    if (el.closest('.carlios-prezzi')) return 'prezzi';
    if (el.closest('.carlios-diagnostica')) return 'quiz';
    if (el.closest('.carlios-prenota')) return 'prenota';
    if (el.closest('.carlios-lavori')) return 'lavori';
    return 'other';
  }

  function initAnalytics() {
    /* CTA + nav clicks — delegated + capture so it also catches CTAs added by
       other scripts (e.g. the Diagnostica end-screen links). */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.closest('.dx__end')) return; // quiz end-screen CTAs are tracked by the quiz's own diag_* events (carry tier/posture)
      var href = a.getAttribute('href') || '';
      var loc = locationOf(a);
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
      var cls = a.classList || { contains: function () { return false; } };
      if (href.indexOf('wa.me') > -1 || href.indexOf('whatsapp.com') > -1 || cls.contains('wa') || cls.contains('nav-mobile__wa') || cls.contains('btn-wa')) {
        track('whatsapp_click', { location: loc, link_text: text });
      } else if (href.lastIndexOf('mailto:', 0) === 0) {
        track('email_click', { location: loc, link_text: text });
      } else if (href.indexOf('calendly.com') > -1 || cls.contains('btn-book') || href.indexOf('#prenota') > -1) {
        track('book_click', { location: loc, link_text: text });
      } else if (a.closest('.nav-links') || a.closest('.nav-mobile__links')) {
        track('nav_click', { location: loc, label: text });
      }
    }, true);

    /* Language switch — header native <select> (change) + footer pills (submit buttons). */
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-lang-select]');
      if (sel) track('language_switch', { location: 'header', to: sel.value });
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.site-footer button[name="locale_code"]');
      if (b) track('language_switch', { location: 'footer', to: b.value });
    }, true);

    /* Section views — fire once when a key funnel section is 40% on screen. */
    if ('IntersectionObserver' in window) {
      var seen = {};
      var secObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var name = en.target.getAttribute('data-ga-section');
          if (name && !seen[name]) { seen[name] = 1; track('section_view', { section: name }); }
          secObs.unobserve(en.target);
        });
      }, { threshold: 0.4 });
      [['.carlios-lavori', 'lavori'], ['.carlios-prezzi', 'prezzi'], ['.carlios-diagnostica', 'diagnostica']].forEach(function (pair) {
        var el = document.querySelector(pair[0]);
        if (el) { el.setAttribute('data-ga-section', pair[1]); secObs.observe(el); }
      });
    }
  }

  /* Content engagement — what people read/open inside the sections.
     `toggle` and `play` don't bubble, so FAQ + pricing detail get per-element
     listeners; Lavori tabs/accordion + Recensioni play are clicks (delegated). */
  function initContentEvents() {
    var t = function (s) { return (s || '').replace(/\s+/g, ' ').trim().slice(0, 120); };

    document.querySelectorAll('.carlios-domande details.qa').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var q = d.querySelector('.qa__q');
        track('faq_open', { question: t(q && q.textContent) });
      });
    });

    document.querySelectorAll('.carlios-prezzi details.pz-detail').forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) track('pricing_detail_open', {}); });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var caseEl = e.target.closest('.carlios-lavori .tab, .carlios-lavori .acc__hd');
      if (caseEl) {
        var lbl = caseEl.querySelector('.tab__type, .acc__type');
        track('lavori_case_view', { case: t(lbl && lbl.textContent) });
        return;
      }
      var stage = e.target.closest('.vr-stage');
      if (stage && !stage.dataset.gaPlayed) {            // once per review (the play, not pause/replay)
        stage.dataset.gaPlayed = '1';
        var card = stage.closest('.vr-card');
        var who = card && card.querySelector('.vr-who');
        track('recensioni_play', { who: t(who && who.textContent) });
      }
    }, true);
  }

  function init() {
    initFaqAccordion();
    initStickyBar();
    initAnalytics();
    initContentEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
